<template>
  <div class="catalog-card-author-img">
    <div class="catalog-card-author-img__main-img">
      <img
        v-if="authorImg"
        :src="getAbsoluteImage(authorImg)"
        alt=""
        loading="lazy"
        width="48"
        height="48"
      />
    </div>

    <div
      v-if="firstUnion"
      :id="tooltipId"
      class="catalog-card-author-img__union-img"
    >
      <img
        :src="firstUnion.logo || defaultUnionImg"
        alt=""
        loading="lazy"
        width="24"
        height="24"
      />
    </div>

    <b-tooltip
      v-if="firstUnion && firstUnion.name"
      :target="tooltipId"
      triggers="hover"
    >
      Учасник спілки {{ firstUnion.name }}
    </b-tooltip>
  </div>
</template>

<script>
import defaultUnionImg from '@/assets/images/union-image.webp';

export default {
  name: 'CatalogCardAuthorImg',
  props: {
    authorImg: {
      type: Object,
      default: null
    },
    unions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    firstUnion() {
      return this.unions && this.unions.length ? this.unions[0] : null;
    },
    tooltipId() {
      return `union-${Math.random().toString(36).slice(2, 11)}`;
    }
  },
  data() {
    return {
      defaultUnionImg
    };
  },
  methods: {
    getAbsoluteImage(path) {
      const baseUrl = process.env.VUE_APP_ENDPOINT_ETC;
      return new URL(path, baseUrl).href;
    }
  }
};
</script>

<style lang="sass">
.catalog-card-author-img
  position: relative
  display: flex
  align-items: flex-end

  &__main-img
    --img-size: 3.125rem

    border-radius: var(--img-size)
    flex: 0 0 var(--img-size)
    width: var(--img-size)
    height: var(--img-size)
    overflow: hidden
    background: url('~@/assets/images/cabinet-photo.webp') no-repeat center / cover

    img
      display: block
      width: 100%
      height: 100%
      object-fit: cover

  &__union-img
    --img-size: 1.5rem

    position: relative
    z-index: 9
    margin-left: calc(var(--img-size) / 1.5 * -1)
    margin-bottom: calc(var(--img-size) / 4 * -1)
    border-radius: var(--img-size)
    flex: 0 0 var(--img-size)
    width: var(--img-size)
    height: var(--img-size)
    overflow: hidden

    img
      display: block
      width: 100%
      max-width: 100%
      height: 100%
      max-height: 100%
      object-fit: cover
</style>
